import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="4"
          height="4"
          fill="none"
          viewBox="0 0 4 4"
        >
          <path
            fill="#172B68"
            d="M0 3.213v.676A.11.11 0 00.111 4h.676a.104.104 0 00.077-.033l2.427-2.424-.834-.834L.033 3.133a.11.11 0 00-.033.08zM3.935.898a.221.221 0 000-.313l-.52-.52a.221.221 0 00-.313 0l-.407.407.833.833.407-.407z"
          ></path>
        </svg>
    );
}